<template>
  <div
    class="owal-domain-picker__container"
  >
    <div
      v-if="domains.length"
      class="owal-domain-picker__at-label"
    >
      at
    </div>
    <multiselect
      v-if="domains.length > 1"
      class="multiselect"
      :options="domains"
      :searchable="true"
      :allow-empty="false"
      track-by="uuid"
      label="description"
      :placeholder="description"
      :show-labels="false"
      :value="description"
      @input="itemSelected"
    >
      <div
        slot="singleLabel"
        class="owal-domain-picker__current-label"
      >
        <div
          class="owal-domain-picker__name"
          @click="togglePicker"
        >
          {{ description }}
        </div>
      </div>
    </multiselect>
    <div
      v-else-if="domains.length === 1"
      class="multiselect"
    >
      <div
        class="owal-domain-picker__current-label"
      >
        <div
          class="owal-domain-picker__name"
        >
          {{ description }}
        </div>
      </div>
    </div>
    <div
      v-else
      class="owal-domain-picker__at-label"
    >
      Loading...
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import '@/assets/css/multiselect.css'

export default {
  name: 'DomainPicker',
  data () {
    return {
      description: 'Loading...',
      showPicker: false,
    }
  },
  beforeMount: function () {
    this.updateSelected()
  },
  computed: {
    ...mapGetters({
      domains: 'domains',
      currentDomain: 'currentDomain',
    }),
  },
  methods: {
    updateSelected: function () {
      this.selected = this.currentDomain
      if (this.currentDomain) {
        this.description = this.currentDomain.description
      } else {
        this.description = 'Loading...'
      }
    },
    itemSelected: function (item) {
      this.selected = item
      this.description = item.description
      this.showPicker = false
      this.$emit('select-domain', item)
    },
    togglePicker () {
      if (this.domains.length < 2) {
        return
      }
      this.showPicker = !this.showPicker
    },
    currentDomainDescription () {
      if (this.selected) {
        if (this.selected.description) {
          return this.selected.description
        }
      }
      return 'Loading...'
    },
  },
  watch: {
    currentDomain: function (newValue) {
      this.updateSelected()
      this.description = this.currentDomainDescription()
    },
  },
  components: {
    Multiselect,
  },
}
</script>

<style scoped>
.owal-domain-picker__container {
  display: flex;
  width: fit-content;
  height: 100%;
  align-items: flex-end;
  justify-content: center;
  align-content: flex-end;
  align-items: flex-end;
  cursor: pointer;
  background-color: none !important;
  border: none !important;
  /* margin-top: 0.55rem; */
  /* background: rgba(255, 255, 255, 0.5); */
}

.owal-domain-picker__container .multiselect {
  transform: translate(0, 2.5px);
}

.owal-domain-picker__at-label {
  font-family: "Avenir-Black";
  display: flex;
  flex-grow: 0;
  flex-shrink: 1;
  /* align-content: flex-end; */
  /* align-items: baseline; */
  font-size: 1rem;
  color: #C0CCDA;
  margin: 0 0.42rem;
  align-self: flex-end;
  padding-bottom: 0;
  transform: translate(0, 4.5px);

}

.owal-domain-picker__name {
  font-family: "Avenir-Black", "Avenir", "Helvetica";
  font-size: 1rem;
  color: #FFFFFF;
}

.owal-domain-picker-dropdown__row {
  color: #C0CCDA;
  background: #324057;
}

.owal-domain-picker__current-label {
  display: flex;
  flex-direction: row;
  width: fit-content;
}

</style>
